/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { ICittaB2bAccountWelcomeTileData } from './citta-b2b-account-welcome-tile.data';
import { ICittaB2bAccountWelcomeTileProps } from './citta-b2b-account-welcome-tile.props.autogenerated';

export interface IAccountWelcomeTileViewProps extends ICittaB2bAccountWelcomeTileProps<ICittaB2bAccountWelcomeTileData> {
    AccountWelcomeTile: IModuleProps;
    className: string;
    heading?: React.ReactNode;
}

/**
 *
 * AccountWelcome component.
 * @extends {React.PureComponent<ICittaB2bAccountWelcomeTileProps<ICittaB2bAccountWelcomeTileData>>}
 */
class AccountWelcomeTile extends React.PureComponent<ICittaB2bAccountWelcomeTileProps<ICittaB2bAccountWelcomeTileData>> {
    public render(): JSX.Element {
        const { config, data } = this.props;
        const { className } = config;

        const accountInfo = data.accountInformation.result;
        const heading = {
            ...config.heading,
            ...{
                text: `${config.heading.text ? config.heading.text : ''} ${
                    accountInfo && accountInfo.Name ? accountInfo.Name : ''
                }`
            }
        };

        const viewProps = {
            ...this.props,
            className,
            AccountWelcomeTile: {
                moduleProps: this.props,
                className: classnames('ms-account-welcome-tile', config.className)
            },
            heading: heading && heading.text && (
                <Msdyn365.Text
                    className='ms-account-welcome-tile__heading'
                    tag={heading.tag}
                    text={heading.text}
                    editProps={{ onEdit: this.handleHeadingChange, requestContext: this.props.context.request }}
                />
            )
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }

    public handleHeadingChange = (event: Msdyn365.ContentEditableEvent) => (this.props.config.heading.text = event.target.value);
}

export default AccountWelcomeTile;
